import React, { useMemo, useState } from 'react'
import { AssetStore } from '../../assets/AssetsStore'
import styles from './index.module.scss'

function Incrementdecrementer({ onChange, value,disabled }) {


    const [counter, setCounter] = useState(0)

    const increase = () => {

        if (counter >= 0) {

            if (counter <= "99998") {
                setCounter(Number(counter) + 1)
            }


            
        }
        else {
            setCounter(0)
        }

    }
    const decrease = () => {

        if (counter >= 1) {

                setCounter(Number(counter) - 1)
    
        }
        else {
            setCounter(0)
        }



    }

    const handleChange = (e) => {

        var rgx = /^[0-9]*\.?[0-9]*$/;
        if (e.match(rgx)) {
            setCounter(e)
        }

    }

    useMemo(() => onChange && onChange(counter), [counter]);


    return (
        <div className={styles.container}>

            <img src={AssetStore.managePrescription.incr} alt="" onClick={decrease} />
            <input disabled={disabled??false} maxLength={5} onChange={(e) => { handleChange(e.target.value) }} className={styles.counter_input} value={value ? value : counter}></input>
            <img src={AssetStore.managePrescription.decr} alt="" onClick={increase} />

        </div>
    )
}

export default Incrementdecrementer